import { useState, useRef, useEffect } from 'react'
import { useNavigate } from "react-router-dom"
import styles from './checkInBtn.module.scss'
import { useTranslation } from 'react-i18next'
import { Button,Modal,Popup,NavBar, Grid, Result, Ellipsis } from 'antd-mobile'
import { ExclamationShieldOutline } from 'antd-mobile-icons'
import { getRewordStaus } from './../../../services/wallets'
import { useDaemonContext } from "./../../../providers/DaemonProvider"
import { CoNET_Data } from '../../../utils/globals'
import { getOracle } from '../../../services/passportPurchase'
import PayWays from './../spWallet/payWays';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const CheckInBtn = ({}) => {
    const { t, i18n } = useTranslation();
	const [disabled, setDisabled] = useState<boolean>(true)
	const [todayCheckIN, setTodayCheckIN] = useState<boolean>(false)
	const [insufficientBalance, setInsufficientBalance] = useState<boolean>(false)
	const { setPaymentKind, setSubscriptionVisible, closestRegion, checkInVisible, setCheckInVisible} = useDaemonContext();
	const navigate = useNavigate()

	let process = false

	const replaceBalance = () => {
		process = false
		setTimeout(() => {
			checkBalance ()
		}, 1000 * 15)
	}


	const getRandomNode = () => {
		if (closestRegion.length === 0) {
			return null
		}
		const index = Math.floor(Math.random()*closestRegion.length)
		return closestRegion[index];
	}
	const checkBalance = async () => {
		const node = getRandomNode()
		if (process||!node) {
			return
		}
		process = true
		const status = await getRewordStaus(node)

		if (status === null) {
			replaceBalance()
			setInsufficientBalance(true)
			return setDisabled(true)
		}

		setInsufficientBalance(false)

		if (status === false) {
			replaceBalance()
			setDisabled(true)
			return setTodayCheckIN(true)
		}

		setDisabled(false)
		setTodayCheckIN(false)
		replaceBalance()
		
	}
	useEffect(()=> {
		checkBalance()
	}, [])

    const spRewordProcess = () => {
        if (disabled) {
            Modal.alert({
                className:styles.warningTipModal,
                content: t('wallet-checkin-btn-warning'),
                closeOnMaskClick: true
            })
            return
        }

        setPaymentKind(5)
        setSubscriptionVisible(true)

    }
    const goCheck = () => {
        setCheckInVisible(true)
    }

    return (
        <>
            <div className={styles.btnWrap}>
                <Button onClick={goCheck} block color='primary' fill='solid'>{t('wallet-checkin-btn')}</Button>
            </div>
            <Popup
                visible={checkInVisible}
                onMaskClick={() => {setCheckInVisible(false)}}
                position='right'
                bodyStyle={{ width: '100%',backgroundColor:'#0d0d0d' }}
                className={styles.popup}
                closeOnMaskClick={true}
                style={{zIndex:'1100'}}
            >
                <div className={styles.modalWrap}>
                    <NavBar onBack={() => {setCheckInVisible(false)}} style={{'--height': '70px'}}>{t('wallet-checkin-btn-title')}</NavBar>
                    <div className={styles.bd}>
						<div className={styles.take}>
							<div className={styles.title}>
								<ExclamationShieldOutline className={styles.icon} />{t('wallet-checkin-info1')}
							</div>
							<div className={styles.title}>
								<ExclamationShieldOutline className={styles.icon} />{t('wallet-checkin-info2')}
							</div>
							<div className={styles.title}>
								<ExclamationShieldOutline className={styles.icon} />{t('wallet-checkin-info3')}
							</div>
							<div className={styles.title}>
								<ExclamationShieldOutline className={styles.icon} />{t('wallet-checkin-info4')}
							</div>
							<div className={styles.title}>
								<ExclamationShieldOutline className={styles.icon} />{t('wallet-checkin-info5')}
							</div>
							<div className={styles.operation}>
								<Button className={styles.btn} block color='primary' size='large' onClick={spRewordProcess}  disabled={disabled}>{t(insufficientBalance ? 'swap-asset-insufficient' : todayCheckIN ? 'comp-RedeemPassport-alreadyRedeem': 'wallet-checkin-betton-title')}</Button>
							</div>
						</div>
						<div className={styles.warning}>
							<div className={styles.title}>
								<ExclamationCircleOutlined style={{marginRight:3}} />{t('wallet-checkin-remind')}
							</div>
							<div className={styles.desc}>
								{t('wallet-checkin-remind-detail')}
							</div>
						</div>
                        <div className={styles.introduce}>
                            <div className={styles.payways}><PayWays defaultVisible={true} /></div>
							{/* <div className={styles.desc}>
								<ExclamationShieldOutline className={styles.icon} />{t('wallet-checkin-deposit-btn-pay-detail')}
							</div> */}
                        </div>

                    </div>
					
					
                </div>
            </Popup>
        </>
    );
};

export default CheckInBtn;